export default __webpack_public_path__ + "static/media/blikco_assistance.9ef48d45.png";